import React from 'react'
import { FaAngleUp } from 'react-icons/fa'
import { isNullOrEmpty } from '../../../shared/scripts'
import "./expansionPanel.css"


const ExpansionPanel = ({
    nameId,
    className = "",
    label = "",
    tooltip = null,
    children = null,
    onChange = null, // useCallback wrapped
    expanded = false,
    icon = <FaAngleUp />
}) => {
    const handleClick = e => {
        const bool = e.target.checked;
        if (onChange != null) {
            onChange(bool);
        }
    };

    return (
        <div
            className={`bon-expansion${isNullOrEmpty(className) ? "" : " " + className}`}
            data-expanded={expanded}
        >
            <label
                title={tooltip}
            >
                <span className="caption">
                    <input
                        type="checkbox"
                        name={nameId}
                        data-toggle="collapse"
                        data-target={`#bon-exp${nameId}`}
                        aria-expanded={expanded}
                        aria-controls={nameId}
                        checked={expanded}
                        onChange={handleClick}
                    />
                    <span className="label">
                        <span className='content'>{label}</span>
                        <span className='background' />
                    </span>
                </span>
                <span
                    className="icon"
                    title={expanded ? "collapse" : "expand"}
                >
                    {icon}
                </span>
            </label>
            <div
                className={`content collapse${expanded ? ' show' : ''}`}
                id={`bon-exp${nameId}`}
            >
                {children != null &&
                    children
                }
            </div>
        </div>
    );
}

export default ExpansionPanel;